<template>
  <div id="app" :class="[is_expand ? 'expanded' : 'collapsed']" :style="{'--color1': style_nigeria?'#488E53':'#097cb1', '--color2':style_nigeria?'#376b3e':'#47b2e4'}">
    <logout-counter />
    <!-- <navigation v-if="page_type=='app' || page_type=='admin'"/> -->
    <top-bar v-if="page_type == 'app' || page_type == 'admin'"></top-bar>
    <main :class="show_aside || show_aside_admin ? 'hh-100' : 'no-mt'">
      <div
        :class="show_aside || show_aside_admin ? 'container-fluid hh-100' : ''"
      >
        <div :class="show_aside || show_aside_admin ? 'row hh-100' : ''">
          <div v-if="show_aside" class="col-md-3 hh-100">
            <asider v-if="!style_nigeria"></asider>
            <asider-nigeria v-if="style_nigeria"></asider-nigeria>
          </div>
          <div v-if="show_aside_admin" class="col-md-3 hh-100">
            <asider-admin></asider-admin>
          </div>
          <div :class="show_aside || show_aside_admin ? 'col-md-9' : ''">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </main>
    <!-- <bottom-bar v-if="page_type=='app'"></bottom-bar> -->
    <b-modal
      id="pwd-3-modal"
      :title="$t('message.password_expires_in_3_days_title')"
      size="sm"
      :hide-footer="true"
    >
      {{ $t("message.password_expires_in_3_days_text") }}
      <div class="text-center mt-4">
        <button
          class="btn btn-primary"
          @click="$bvModal.show('modal-change-password-3')"
        >
          {{ $t("message.account.change_password") }}
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-change-password-3"
      centered
      :hide-footer="true"
      size="lg"
      :title="$t('message.account.change_password')"
    >
      <div class="form-group">
        <password
          v-model="old_password"
          :placeholder="$t('message.account.old_password')"
          id="old_password"
        />
        <!-- <label for="old_password">{{$t('message.account.old_password')}}</label> -->
        <!-- <input type="password" id="old_password" class="form-control" v-model="old_password"> -->
      </div>
      <div class="text-danger" v-if="wrong_old_password">
        {{ $t("message.account.old_password_wrong") }}
      </div>
      <div class="text-danger" v-if="insecure_new_password">
        {{ $t("message.account.insecure_new_password") }}
      </div>
      <div class="text-danger" v-if="short_new_password">
        {{ $t("message.account.short_new_password") }}
      </div>

      <div class="form-group">
        <password
          v-model="new_password"
          :placeholder="$t('message.account.new_password')"
          id="new_password"
        />
        <!-- <label for="new_password">{{$t('message.account.new_password')}}</label> -->
        <!-- <input type="password" id="new_password" class="form-control" v-model="new_password"> -->
      </div>
      <div class="form-group">
        <password
          v-model="confirm_password"
          :placeholder="$t('message.account.confirm_password')"
          id="confirm_password"
        />
        <!-- <label for="confirm_password">{{$t('message.account.confirm_password')}}</label> -->
        <!-- <input type="password" id="confirm_password" class="form-control" v-model="confirm_password"> -->
      </div>
      <button class="btn btn-success" @click="savePassword">
        {{ $t("message.save") }}
      </button>
    </b-modal>
  </div>
</template>

<script>
import LogoutCounter from "./components/logout-counter.vue";
import password from "./components/fields/password.vue";
import asider from "./components/asider.vue";
import AsiderNigeria from "./components/asider-nigeria.vue";
import AsiderAdmin from "./components/asider-admin.vue";
export default {
  name: "App",
  components: { LogoutCounter, password, asider, AsiderAdmin, AsiderNigeria },
  data() {
    return {
      old_password: "",
      new_password: "",
      confirm_password: "",

      wrong_old_password: false,
      short_new_password: false,
      insecure_new_password: false,
    };
  },
  mounted() {
    this.checkPasswordExpiry();
    if (window.location.hostname == "attistrade.cn") {
      document.title = "attis cn";
      // window.location.hash = '#/app' AT-737
    } else if (window.location.hostname == "attistrade.kz")
      document.title = "attis kz";
    else if (
      window.location.hostname == "attistrade.ru" ||
      window.location.hostname == "attis-trade.ru"
    )
      document.title = "attis trade rus";
    else if (window.location.hostname == "test.attistrade.kz")
      document.title = "attis test";
    else document.title = "attis dev";

    this.$root.$on("logout", () => {
      // window.updateToken()
    });
  },
  methods: {
    /**
     * Saves new password
     */
    savePassword() {
      if (
        !_.isEmpty(this.old_password) &&
        !_.isEmpty(this.new_password) &&
        !_.isEmpty(this.confirm_password)
      ) {
        if (this.new_password != this.confirm_password) {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.account.passwords_not_equal"),
            timeout: 5000,
          }).show();
        } else {
          var formdata = new FormData();
          formdata.append("old_password", this.old_password);
          formdata.append("new_password", this.new_password);
          axios
            .post(window.base + "/account/savePassword", formdata)
            .then((response) => {
              if (response.data.status == "ok") {
                this.$bvModal.hide("modal-change-password");
                this.wrong_old_password = false;
              } else {
                if (response.data.status == "Incorrect password.") {
                  this.wrong_old_password = true;
                } else {
                  if (
                    response.data.status ==
                    "Пароль должен иметь длинну 8 символов"
                  ) {
                    this.short_new_password = true;
                  } else {
                    this.insecure_new_password = true;
                  }
                }
              }
            });
        }
      } else {
        new Noty({
          theme: "light",
          type: "error",
          text: this.$t("message.account.fill_all_fields"),
          timeout: 5000,
        }).show();
      }
    },
    /**
     * Checks how many days left to change password
     */
    checkPasswordExpiry() {
      // this.$bvModal.show('pwd-3-modal')
      axios.get(window.base + "/account/getpassdays").then((response) => {
        if (parseInt(response.data, 10) <= 3) {
          if (!document.querySelector("#modal-change-password-exp.show"))
            this.$bvModal.show("pwd-3-modal");
        }
      });
    },
  },
  computed: {
    style_nigeria(){
      return ["full", "full-mac"].includes(process.env.VUE_APP_MODE)
    },
    
    show_aside() {
      if (this.page_type == "app") return true;
      return false;
    },
    show_aside_admin() {
      if (this.page_type == "admin") return true;
      return false;
    },
    style() {
      if (window.dev_mode)
        return {
          // '--bg': 'url(/'+this.$i18n.locale+'.jpg)',
          // '--bg': 'url(/hero-img.jpg)'
        };
      return {
        // '--bg': 'url(/cover.jpg)',
        // '--bg': 'url(/hero-img.jpg)'
      };
    },
    is_expand() {
      return this.$store.state.expand;
    },
    page_type() {
      if (
        this.$route.name == "homepage-index" ||
        this.$route.name == "sign-in" ||
        this.$route.name == "sign-up" ||
        this.$route.name == "homepagenew-index" ||
        this.$route.name == "homepagenew-index" ||
        this.$route.name == "education-guest"
      ) {
        return "home";
      }
      if (this.$route.name.includes("admin")) {
        return "admin";
      }
      return "app";
    },
  },
};
</script>

<style lang="scss">
.welcome {
  // background-image: url('./components/homepage/assets/img/hero-img.jpg') !important;
  background-blend-mode: normal !important;
  background-color: transparent !important;
}
.welcome:before {
  display: none !important;
}
.main-really-raised,
.main-really-raised .container {
  transition:
    width 0.5s,
    max-width 0.5s,
    min-width 0.5s;
}
.expanded {
  .main-really-raised {
    width: 90% !important;
    min-width: 90% !important;

    .container {
      max-width: 100% !important;
    }
  }
}
.form-label-group > label.form-label-group-label {
  color: #2e2d2d !important;
}
.form-control {
  color: #000 !important;
  font-weight: 400 !important;
}
.hh-100 {
  min-height: 100vh;
}
main {
  margin-top: 32px;
}
main.no-mt,
main.no-mt main {
  margin-top: 0 !important;
}
.container {
  max-width: 1220px !important;
}
body {
  background-color: #eee !important;
}
</style>
<style>
:root {
  --color1: #097cb1;
  --color2: #47b2e4;
}
.text-button {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500 !important;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: var(--color1) !important;
}
/* .text-button svg path {
  fill: var(--color1) !important;
} */
.text-button:hover,
.form-check-label a.text-dark:hover {
  color: var(--color2) !important;
}
/* .text-button:hover svg path {
  fill: var(--color2) !important;
} */
.form-group label {
  cursor: default !important;
}
.btn.btn-sm.btn-outline-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 12px;
  gap: 8px;

  height: 30px;

  /* neutral/10 */

  border: 1px solid #333333;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;

  /* neutral/10 */

  color: #333333;
}
.btn.btn-sm.btn-outline-secondary:hover {
  background: #e6e6e6;
}
.btn.btn-sm.btn-outline-secondary:disabled {
  border: 1px solid #b1b1b1;
  color: #797980;
}
.modal-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  /* identical to box height, or 117% */

  /* neutral/10 */

  color: #333333;
}
.modal-body {
  padding-top: 0;
  padding-bottom: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* neutral/10 */

  color: #333333;
}
.modal-footer {
  border-top: 0 !important;
}
.modal-footer.p-2 {
  padding-bottom: 20px !important;
  padding-right: 20px !important;
}

.modal-footer .btn-success,
.modal-footer .btn-primary,
.modal-footer .btn-info {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 40px;
  gap: 16px;

  width: 179px;
  height: 48px;

  /* attis/gradient light */

  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
  border: 0;
  transition: none;
}
.btn.btn-success {
  transition: none;
}
.modal-footer .btn-success:hover,
.modal-footer .btn-primary:hover,
.modal-footer .btn-info:hover,
.modal-footer .btn-success:active,
.modal-footer .btn-primary:active,
.modal-footer .btn-info:active,
.modal-footer .btn-success:focus,
.modal-footer .btn-primary:focus,
.modal-footer .btn-info:focus,
.btn.btn-success:active,
.btn.btn-success:focus {
  background: var(--color2) !important;
}
.modal-footer .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 40px;
  gap: 16px;

  width: 138px;
  height: 48px;

  /* neutral/10 */
  background: transparent;
  border: 1px solid #333333;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* neutral/10 */

  color: #333333;
}
.modal-footer .btn-secondary:hover {
  background: #e6e6e6;
}
.modal-header,
.modal-body {
  padding: 24px 28px !important;
}
.modal-header .close,
.modal-header .close:hover {
  color: transparent !important;
  background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.2928 5.2928C5.68332 4.90228 6.31649 4.90228 6.70701 5.2928L11.9999 10.5857L17.2928 5.2928C17.6833 4.90228 18.3165 4.90228 18.707 5.2928C19.0975 5.68332 19.0975 6.31649 18.707 6.70701L13.4141 11.9999L16.4141 14.9999L18.707 17.2928C19.0975 17.6833 19.0975 18.3165 18.707 18.707C18.3165 19.0975 17.6833 19.0975 17.2928 18.707L11.9999 13.4141L6.70701 18.707C6.31649 19.0975 5.68332 19.0975 5.2928 18.707C4.90228 18.3165 4.90228 17.6833 5.2928 17.2928L10.5857 11.9999L5.2928 6.70701C4.90228 6.31649 4.90228 5.68332 5.2928 5.2928Z" fill="%23797980"/></svg>') !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  opacity: 1 !important;
}
.page-item.active .page-link {
  padding-left: 4px;
  padding-right: 4px;
}
.btn-link{
  color: var(--color1) !important;
}
.btn-outline-primary{
  color: var(--color1) !important;
  border-color: var(--color1) !important;
}
.btn-outline-primary:hover,
.btn-outline-primary:active,
.btn-outline-primary:focus{
  background-color: var(--color1) !important;
  color: #fff !important;
}
.card .tabs .nav-link.active{
  border-bottom-color: var(--color2) !important;
}
.list-group-item.active{
  background-color: var(--color1) !important;
  border-color: var(--color1) !important;
}
.validation-frame{
  position: absolute !important;
  top: 20px !important;
  left: unset !important;
  right: 20px !important;
}
</style>
